import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/book/new")({
  component: lazyRouteComponent(
    () => import("../pages/Book/CreateAndRedirect"),
    "CreateAndRedirect",
  ),
});
